import componentHelpers from '../componentLibrary/componentHelpers.js'
import * as $ from 'jquery';

class LiquidString {
    value;
    id;
    ubject_type = "LiquidString";
    edits = [];
    replacements = []; //Temporary in transition from params to liquid-syntax
    eventBroker;

    constructor(text, id) {
        this.value = text;
        this.id = id;
    }

    updateText(input) {
        if (input instanceof LiquidString)
            this.value = input.getTemplate();
        else if (typeof (input) === 'string')
            this.value = input;
        else if (typeof (input) === 'object')
            this.value = input.value;

        for (var before in this.replacements) {
            this.value = this.value.replaceAll(before, this.replacements[before]);
        }
    }

    getTemplate() {
        return this.value;
    }

    getUniqueId() {
        return this.id;
    }

    getTag(tag, cssClasses) {
        let element = `<${tag} id="${this.getUniqueId()}"></${tag}>`;
        if (cssClasses)
            element = `<${tag} id="${this.getUniqueId()}" class="${cssClasses}"></${tag}>`;

        let $element = $(element);
        $element.append(this.getEditedTemplate().contents());

        return $element;
    }

    setEdit(key, value) {

        if (this.value && this.value.includes(`{{${key}}}`)) {
            this.edits[key] = value;
            this.updateUI();
        }
    }

    updateUI() {
        let id = this.getUniqueId();
        let $content = this.getEditedTemplate();
        $(`#${id}`).empty().append($content.contents());
    }

    getEditedTemplate() {
        let output = this.value;

        for (var i in this.edits) {
            output = output.replaceAll(`{{${i}}}`, this.edits[i])
        }

        let html = componentHelpers.mdToHtml(output);

        let $html = this.hookupEvents(html);

        return $html;
    }

    hookupEvents(html) {
        let $html = $(`<div>${html}</div>`);
        if (html.includes("redirect")) {
            $html.find(".redirect").on("click", function (e) {
                let url = $(e.currentTarget).data("url");
                let type = $(e.currentTarget).data("type");
                this.eventBroker.fire("redirectEvent", {
                    "url": url,
                    "type": type
                });
            }.bind(this));
            return $html;
        } else if (html.includes("internal-next-button")) {
            $html.find(".internal-next-button").one("click", function (e) {
                $(".next-button").trigger("click");
            });
            return $html;
        }
        return $html;
    }

    replace(before, after) {
        this.replacements[before] = after;
        this.value.replaceAll(before, after);
    }

    static getSimpleString(input) {
        if (input instanceof LiquidString)
            return input.getTemplate();

        if (typeof (input) === 'string')
            return input;

        if (typeof (input) === 'object' && input.value)
            return input.value;

        return "ERROR IN getSimpleString";
    }
}

export { LiquidString }
